import { checkWxSDKReady } from './util';

// 因为新的分享都需要签名，所以base-libs都已经替换成新的方式了
// 所以老的方式，代码直接拷贝到util中

const shareHanlder = {
  // 发送给朋友
  appmessage(config, callback) {
    WeixinJSBridge.invoke('sendAppMessage', config, callback);
  },
  // 朋友圈分享
  timeline(config, callback) {
    WeixinJSBridge.invoke('shareTimeline', config, callback);
  },
};

function bindShare(config, callback) {
  WeixinJSBridge.on('menu:share:appmessage', () => {
    shareHanlder.appmessage(formatConfig(config), (...args) => {
      callback && callback({ type: 'appmessage' }, ...args);
    });
  });
  WeixinJSBridge.on('menu:share:timeline', () => {
    shareHanlder.timeline(formatConfig(config), (...args) => {
      callback && callback({ type: 'timeline' }, ...args);
    });
  });
}

/**
 * 把cofig的写法符合微信参数
 * @param config
 */
function formatConfig({ imgUrl, url, title, desc }) {
  return {
    img_url: imgUrl,
    img_width: '240',
    img_height: '240',
    link: url || location.href,
    desc: desc || document.title,
    title: title || document.title,
  };
}

export default function (config, callback) {
  checkWxSDKReady(() => {
    bindShare(config, callback);
  });
}
